module.exports = __webpack_public_path__ + "static/media/landmark-alt.483ed087.svg";